import { Link } from "react-router-dom";
import { Mail } from "lucide-react";

/**
 * Standard MoR-compliant footer.
 * Rendered on every page except /menu/:id (Guest Menu).
 * Links to policy placeholder pages (/terms, /refund-policy, /privacy) so
 * payment underwriters + Merchant-of-Record reviewers see a clear support
 * channel and policy surface from any page.
 */
export default function Footer() {
  const year = new Date().getFullYear();
  const supportEmail = "admin@kritajnaventures.com";

  return (
    <footer
      className="bg-slate-950 border-t border-slate-800 mt-auto"
      data-testid="site-footer"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
          <div className="text-sm text-slate-400 text-center md:text-left">
            <span className="font-semibold text-slate-200">PlateProfit</span>
            <span className="mx-2 text-slate-600">·</span>
            <span>© {year} Kritajna Ventures LLP. All rights reserved.</span>
          </div>

          <nav
            className="flex flex-wrap items-center gap-x-5 gap-y-2 text-sm justify-center"
            aria-label="Footer"
          >
            <Link
              to="/terms"
              className="text-slate-400 hover:text-amber-400 transition-colors"
              data-testid="footer-link-terms"
            >
              Terms &amp; Conditions
            </Link>
            <Link
              to="/refund-policy"
              className="text-slate-400 hover:text-amber-400 transition-colors"
              data-testid="footer-link-refund"
            >
              Refund &amp; Cancellation Policy
            </Link>
            <Link
              to="/privacy"
              className="text-slate-400 hover:text-amber-400 transition-colors"
              data-testid="footer-link-privacy"
            >
              Privacy Policy
            </Link>
            <a
              href={`mailto:${supportEmail}`}
              className="flex items-center gap-1.5 text-slate-400 hover:text-amber-400 transition-colors"
              data-testid="footer-link-contact"
            >
              <Mail className="h-3.5 w-3.5" />
              <span>{supportEmail}</span>
            </a>
          </nav>
        </div>
      </div>
    </footer>
  );
}
